import React from "react";
import {
  TabbedForm,
  FormTab,
  TextField,
  TextInput,
  DateInput,
  BooleanInput,
  ReferenceField,
  Toolbar,
  DeleteButton,
  SelectInput,
  required
} from "react-admin";
import TimeInput from "../fields/TimeInput";
import LocationReferenceInput from "./LocationReferenceInput";
import SaveWithLocationButton from "./SaveWithLocationButton";
import { getSchoolNameFromGame } from "games/utils";
import { transformNotFootballPlaysBlob } from "games/model/transformations";
import GameStatusSelect from "./GameStatusSelect";
import Stats from "./stats";
import { useFormState } from "react-final-form";
import ChangeTeamsButton from "./ChangeTeamsButton";

const transformData = (data) => {
  const playsBlob = transformNotFootballPlaysBlob(data);
  return {
    ...data,
    playsBlob: playsBlob
  };
};

const GameEditToolbar = (props) => (
  <Toolbar style={{ justifyContent: "space-between" }} {...props}>
    <SaveWithLocationButton
      label="Save Game"
      redirect={false}
      transform={transformData}
    />
    <DeleteButton undoable={false} redirect="/games" />
  </Toolbar>
);

const GameStatusDisplay = () => {
  const { values } = useFormState();
  const gameStatus = values.gameStatus ? values.gameStatus : "No Status Set";
  return <h4>Game Status: {gameStatus}</h4>;
};

const ActionTab = () => {
  const { values } = useFormState();
  return <ChangeTeamsButton game={values} />;
};

const GameEditSport = (props) => {
  const { record } = props;
  const homeSchoolName = getSchoolNameFromGame(record, "home");
  const awaySchoolName = getSchoolNameFromGame(record, "away");

  return (
    <TabbedForm {...props} toolbar={<GameEditToolbar />}>
      <FormTab label={`${awaySchoolName} Stats`}>
        <GameStatusDisplay />
        <Stats side="away" />
      </FormTab>
      <FormTab label={`${homeSchoolName} Stats`}>
        <GameStatusDisplay />
        <Stats side="home" />
      </FormTab>
      <FormTab label="Info">
        <GameStatusDisplay />
        <TextField source="id" />
        <TextField source="seasonCode" label="Season" />
        <ReferenceField
          link={false}
          label="Sport"
          source="sportCode"
          reference="sportCodes"
        >
          <TextField source="label" />
        </ReferenceField>
        <DateInput
          label="Date"
          source="gameDateString"
          validate={[required()]}
        />
        <TimeInput label="Time" source="gameTimeString" />
        <BooleanInput label="Is District Game" source="gameIsDistrict" />
        <BooleanInput label="Is Top Game" source="isTopGame" />
        <SelectInput
          source="playoffRound"
          allowEmpty={true}
          choices={[
            { id: "BI_DISTRICT", name: "Bi-District" },
            { id: "AREA", name: "Area" },
            { id: "REGIONAL_QUARTERFINAL", name: "Regional Quaterfinal" },
            { id: "REGIONAL_SEMIFINAL", name: "Regional Semifinal" },
            { id: "REGIONAL_FINAL", name: "Regional Final" },
            { id: "STATE_SEMIFINAL", name: "State Semifinal" },
            { id: "STATE_FINAL", name: "State Final" }
          ]}
        />
        <LocationReferenceInput
          source="location"
          reference="locations"
          allowEmpty
        />
        <GameStatusSelect />
        <TextInput
          source="internalNotes"
          label="Internal Notes"
          multiline
          rows={4}
        />
      </FormTab>
      <FormTab label="Actions">
        <ActionTab />
      </FormTab>
    </TabbedForm>
  );
};

export default GameEditSport;
